<div
  data-cy="product-card-ellipsis-section"
  class="ellipsis"
  [class.disabled]="notFound"
  (click)="!notFound ? ellipsisClick($event) : null"
  *ngIf="!isGuestUser"
>
  <ion-icon
    class="ellipsis-icon"
    data-cy="product-card-ellipsis-icon"
    name="ellipsis-vertical-circle-sharp"
  ></ion-icon>
</div>
